<template>
  <section class="single-image-block">
    <figure v-if="image?.url" class="mb-0">
      <img
        :src="image.url"
        :alt="image.title || ''"
        :width="image.width"
        :height="image.height"
        loading="lazy"
      />

      <figcaption
        v-if="image.caption"
        class="image-caption text-sm text-family-secondary pt-2"
      >
        {{ image.caption }}
      </figcaption>
    </figure>
  </section>
</template>

<script setup>
defineProps({
  image: { type: Object, required: true }
})
</script>
